"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaSizes = exports.ListRowImage = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../Image/index.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["size", "imageWidth", "imageHeight", "borderRadius", "alt"];
var mediaSizes = exports.mediaSizes = {
  sm: (0, _layoutTheme.cssGraphicSize)('smaller', 'decorative', '16px') /* TODO: should this use an informative graphic size token if alt text is provided?  */,
  md: (0, _layoutTheme.cssGraphicSize)('base', 'decorative', '24px') /* TODO: should this use an informative graphic size token if alt text is provided? */,
  lg: (0, _layoutTheme.cssGraphicSize)('larger-3', 'decorative', '48px') /* TODO: should this use an informative graphic size token if alt text is provided? */,
  xl: (0, _layoutTheme.cssGraphicSize)('larger-4', 'decorative', '64px') /* TODO: should this use an informative graphic size token if alt text is provided? */,
  xxl: (0, _layoutTheme.cssGraphicSize)('larger-5', 'decorative', '88px') /* TODO: should this use an informative graphic size token if alt text is provided? */
};
var ListRowImageComponent = (0, _styledComponents["default"])(_index.Image).withConfig({
  displayName: "ListRowImage__ListRowImageComponent",
  componentId: "sc-1uaxq9n-0"
})(["flex-shrink:0;object-fit:cover;"]);

/**
 * ListRowImage can be used as a component to pass into the media prop on ListRow.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list-listrow-listrowimage--docs) |
 * [Encore site](https://encore.spotify.net/web/components/lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListRowImage)
 */
var ListRowImage = exports.ListRowImage = function ListRowImage(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    imageWidth = _ref.imageWidth,
    imageHeight = _ref.imageHeight,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? (0, _layoutTheme.cssBorderRadius)('base', '4px') : _ref$borderRadius,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (imageWidth || imageHeight) {
    return /*#__PURE__*/_react["default"].createElement(ListRowImageComponent, Object.assign({
      alt: alt,
      imageWidth: imageWidth,
      imageHeight: imageHeight,
      borderRadius: borderRadius,
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ListRowImage
    }, props));
  }
  return /*#__PURE__*/_react["default"].createElement(ListRowImageComponent, Object.assign({
    alt: alt,
    imageWidth: mediaSizes[size],
    imageHeight: mediaSizes[size],
    borderRadius: borderRadius
  }, props));
};